import { Component, Inject, OnInit } from "@angular/core";
import { AppService } from "src/_services/app.service";
import { UserService } from "src/_services/user.service";
import { ActivatedRoute, Router } from "@angular/router";
import { Users } from "src/_models/user";
import { FormControl } from "@angular/forms";
import { MAT_DIALOG_DATA } from "@angular/material";
@Component({
  selector: 'app-edit-user',
  templateUrl: './edit-user.component.html',
  styleUrls: ['./edit-user.component.scss']
})
export class EditUserComponent implements OnInit {
  private role: string[];
  private user: Users;
  operatorData = [];
  filteredOperatorData = [];
  operatorSearchText = "";
  operators = new FormControl("");
  operatorId: string;
  selectedRole: string;
  selectedOperators: string[];
  DATA: any
  invoiceControl = new FormControl(false);
  twoFaControl = new FormControl(false);

  constructor(
    private appService: AppService,
    private userService: UserService,
    private router: Router,
    private activatedRoute: ActivatedRoute,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {
    this.DATA = data
  }

  ngOnInit() {
    this.getRoleType();
    this.getOperatorData();
    this.role = [];
    this.invoiceControl.setValue(this.DATA.invoice);
    this.twoFaControl.setValue(!!this.DATA.TwoFAEnabled);
    this.activatedRoute.queryParams.subscribe((params) => {
      this.operatorId = this.DATA.operatorId;
      this.selectedOperators = this.DATA.operators;
      this.user = new Users({
        user_id: this.DATA.userId,
        role: this.DATA.role,
        user_name: this.DATA.userName,
        invoice: this.invoiceControl.value,
        "2fa": this.twoFaControl.value,
      });
    });
    if (this.user.role === "GroupAdmin" || this.user.role === "GroupUser" || this.user.role === "MetricsAdmin") {
      this.operators.setValue(this.selectedOperators);
    } else {
      this.operators.setValue(this.operatorId);
    }
  }
  getOperatorData() {
    try {
      this.appService.getOperatorId().subscribe((res) => {
        if (res.status === "RS_OK") {
          this.operatorData = res.operators;
          this.filterOperators();
        } else {
          if (res.errorDescription === "Invalid Token!") {
            sessionStorage.clear();
            this.router.navigateByUrl("/login");
          }
        }
      });
    } catch (err) {}
  }
  getRoleType() {
    try {
      this.userService.getRoleType().subscribe((res) => {
        if (res.status === "RS_OK") {
          this.role = res.roles;
          this.role = this.role.concat(["GroupAdmin","InvoiceAdmin"]);
        } else {
          if (res.errorDescription === "Invalid Token!") {
            sessionStorage.clear();
            this.router.navigateByUrl("/login");
          }
        }
      });
    } catch (err) {}
  }
  redirectAddOperatorPage() {
    this.router.navigate(["administration/users"]);
  }

  onSelectedRole(val) {
    this.user.role = val;
    this.operators.setValue("");
    this.operatorSearchText = "";
    this.filterOperators();
  }

  filterOperators() {
    const q = (this.operatorSearchText || "").toLowerCase().trim();
    if (!q) {
      this.filteredOperatorData = this.operatorData.slice();
      return;
    }
    this.filteredOperatorData = this.operatorData.filter((o) =>
      String(o.operator_id).toLowerCase().includes(q)
    );
  }

  onOperatorSelectOpened(open: boolean) {
    if (open) {
      this.operatorSearchText = "";
      this.filterOperators();
    }
  }

  get isValid() {
    if (this.user.user_id !== "" && this.user.user_id !== null && this.user.user_name !== "" && 
    this.user.user_name !== null  && this.user.role !== "" && this.user.role !== null && 
    this.operators.value !== "" && this.operators.value !== null) {
      return false;
    }
    return true;
  }

  onFormSubmit({ value, valid }: { value: Users; valid: boolean }) {
    console.log(this.user);
    if (this.user.role === "GroupAdmin" || this.user.role === "GroupUser" || this.user.role === "MetricsAdmin") {
      this.user.operators = this.operators.value;
      this.user.operator_id = null;
    }else{
      this.user.operator_id = this.operators.value;
      this.user.operators = null;
    }
    this.user.invoice = this.invoiceControl.value;
    this.user["2fa"] = this.twoFaControl.value;
    try {
      this.appService.updateUser(this.user).subscribe((res) => {
        if (res.status === "RS_OK") {
          this.appService.openSuccessBar(res.errorDescription);
          this.router.navigateByUrl("administration/users");
        } else {
          this.appService.openErrorBar(res.errorDescription);
        }
      });
    } catch (err) {
      console.log("err", err);
    }
  }
}
